import { getMessage } from '@tcc/i18n';
import { Button, ButtonFill, ComponentColor, DialogContent, DialogFooter, Typography, TypographyVariant } from '@tcc/fds';
import { BaseFieldRegionReportModalParams } from '../types/modals';
import { RegionReportModal } from '../RegionReportModal';

export interface CloseConfirmationViewProps extends BaseFieldRegionReportModalParams {
  index: number;
  onCancelConfirm: () => void;
  onCancelGoBack: () => void;
}

export const CloseConfirmationView = ({
  index,
  dialogTestId,
  onCancelConfirm,
  onCancelGoBack,
  onOpenChange
}: CloseConfirmationViewProps) => (
  <RegionReportModal
    dialogTestId={dialogTestId}
    modalViewKey={`${index}-close-confirmation`}
    onOpenChange={onOpenChange}
  >
    <DialogContent key="close-confirmation-view" testId='dmb-region-report-close-confirmation-modal'>
      <Typography variant={TypographyVariant.Heading}>
        {getMessage('regions.report.modal.confirm.close')}
      </Typography>
      <Typography variant={TypographyVariant.Body}>
        {getMessage('regions.report.modal.confirm.close.subheading')}
      </Typography>
    </DialogContent>
    <DialogFooter>
      <Button
        testId='confirmation-modal-go-back-button'
        onClick={onCancelGoBack}
        fill={ButtonFill.Outline}
        color={ComponentColor.Primary}>
          {getMessage('confirmationModal.goBack')}
      </Button>
      <Button
        testId='confirmation-modal-confirm-button'
        onClick={onCancelConfirm}
        fill={ButtonFill.Solid}
        color={ComponentColor.Primary}>
          {getMessage('confirmationModal.close')}
      </Button>
    </DialogFooter>
  </RegionReportModal>
);
